<div class="confirm-modal-container">
  <ion-card class="profilebody ion-no-margin">
    <ion-row class="header-row">
      <h3>{{ CONSTANTS.HEADER }}</h3>
      <img [src]="IMAGES.CLOSE" alt="close" (click)="dialogRef.close()" />
    </ion-row>
    <div class="body">
      <div class="msg">{{ CONSTANTS.FOLLOWING_FILE }}</div>
      <div class="file-container">
        @if (fileName.endsWith(".txt")) {
          <ion-icon src="assets/file-icon.svg" class="csv-file-icon"></ion-icon>
        } @else {
          <ion-icon src="assets/csv-file.svg" class="csv-file-icon"></ion-icon>
        }
        <p class="file-name">{{ fileName }}</p>
      </div>
    </div>
    <!-- footer -->
    <ion-row class="footer-row ion-justify-content-between">
      <ion-button fill="outline" class="cancel-btn" (click)="dialogRef.close()">
        {{ CONSTANTS.BACK }}
      </ion-button>
      <ion-button fill="fill" class="submit-btn" (click)="dialog.closeAll()">
        {{ CONSTANTS.CONFIRM }}
      </ion-button>
    </ion-row>
  </ion-card>
</div>
